import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "min-h-screen bg-white"
}
const _hoisted_2 = { class: "bg-yellow-50 border-b border-yellow-200 px-6 py-2 flex items-center justify-between sticky top-0 z-20" }
const _hoisted_3 = { class: "text-sm text-yellow-700 font-medium flex items-center gap-2" }
const _hoisted_4 = {
  key: 0,
  class: "px-2 py-0.5 bg-yellow-200 text-yellow-800 rounded text-xs"
}
const _hoisted_5 = { class: "bg-white px-[18px] md:px-[70px] pt-8 pb-10" }
const _hoisted_6 = { class: "flex flex-col md:flex-row gap-8 md:gap-12 mb-10 md:mb-14" }
const _hoisted_7 = { class: "w-full md:w-[45%] shrink-0 bg-gray-100 aspect-[16/9] md:aspect-auto md:h-[340px] overflow-hidden rounded-xl" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center text-gray-300"
}
const _hoisted_10 = { class: "flex-1 flex flex-col justify-center gap-6" }
const _hoisted_11 = {
  class: "font-[800] text-[28px] md:text-[38px] leading-tight mb-4 article-copy",
  style: {"color":"#003793"}
}
const _hoisted_12 = {
  key: 0,
  class: "flex flex-wrap gap-2 mb-4"
}
const _hoisted_13 = { class: "text-sm text-gray-400" }
const _hoisted_14 = { class: "flex flex-col md:flex-row gap-8 md:gap-10 items-start mb-10" }
const _hoisted_15 = { class: "w-full md:w-80 shrink-0 border border-gray-200 rounded-2xl px-6 py-6 shadow-sm md:sticky md:top-[57px]" }
const _hoisted_16 = { class: "mb-5 space-y-1" }
const _hoisted_17 = {
  key: 1,
  class: "text-sm text-gray-600 flex items-center gap-2"
}
const _hoisted_18 = { class: "text-sm text-gray-600 mb-5" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "flex flex-wrap gap-1.5" }
const _hoisted_21 = { class: "flex-1 min-w-0 w-full" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  key: 1,
  class: "min-h-screen bg-white flex items-center justify-center"
}

import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { GET_ACTIVITY_BY_ID } from '@/store/activity.module';


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityPreviewView',
  setup(__props) {

const route = useRoute();
const store = useStore();
const activity = ref<any>(null);
const activityId = computed(() => Number(route.params.id));

const formatDate = (dateStr: string) => {
  if (!dateStr) return '-';
  const value = String(dateStr);
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
  const date = dateOnly ? new Date(`${value}T12:00:00+07:00`) : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'Asia/Jakarta',
  }).format(date);
};

const closeWindow = () => window.close();

onMounted(async () => {
  activity.value = await store.dispatch(GET_ACTIVITY_BY_ID, activityId.value);
});

return (_ctx: any,_cache: any) => {
  return (activity.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              }),
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              })
            ], -1)),
            _cache[1] || (_cache[1] = _createTextVNode(" Mode Preview ", -1)),
            (activity.value.status === 'draft')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Draft"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            onClick: closeWindow,
            class: "text-sm text-yellow-600 hover:underline"
          }, "Tutup")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (activity.value.image)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: activity.value.image,
                    alt: activity.value.title,
                    class: "w-full h-full object-cover"
                  }, null, 8, _hoisted_8))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("svg", {
                      class: "w-16 h-16",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "1",
                        d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                      })
                    ], -1)
                  ]))]))
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _createElementVNode("h1", _hoisted_11, _toDisplayString(activity.value.title), 1),
                (activity.value.tags?.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.value.tags, (tag) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: tag.id,
                          class: "px-3 py-1 text-xs font-semibold rounded-full",
                          style: {"background-color":"#003793","color":"white"}
                        }, _toDisplayString(tag.name), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_13, " Dipublish pada " + _toDisplayString(formatDate(activity.value.date)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3" }, "Ditulis oleh", -1)),
              _createElementVNode("ul", _hoisted_16, [
                (activity.value.contributors?.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(activity.value.contributors, (contributor, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: "text-sm text-gray-600 flex items-center gap-2"
                      }, [
                        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "w-1.5 h-1.5 rounded-full bg-gray-400 shrink-0" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(contributor), 1)
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("li", _hoisted_17, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("span", { class: "w-1.5 h-1.5 rounded-full bg-gray-400 shrink-0" }, null, -1),
                      _createTextVNode(" IOM ITB ", -1)
                    ]))]))
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1" }, "Dipublikasikan", -1)),
              _createElementVNode("p", _hoisted_18, _toDisplayString(formatDate(activity.value.date)), 1),
              (activity.value.tags?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2" }, "Kategori", -1)),
                    _createElementVNode("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.value.tags, (tag) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: tag.id,
                          class: "px-2.5 py-1 text-xs font-semibold rounded-full",
                          style: {"background-color":"#003793","color":"white"}
                        }, _toDisplayString(tag.name), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_21, [
              (activity.value.description)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "activity-content mx-auto mb-8",
                    innerHTML: activity.value.description
                  }, null, 8, _hoisted_22))
                : _createCommentVNode("", true),
              _createElementVNode("div", { class: "article-actions mx-auto" }, [
                _createElementVNode("button", {
                  onClick: closeWindow,
                  class: "inline-flex items-center gap-2 px-4 py-2 text-[16px] font-medium text-white rounded-full hover:opacity-80 transition-opacity",
                  style: {"background-color":"#003793"}
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("svg", {
                    class: "w-4 h-4",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M10 19l-7-7m0 0l7-7m-7 7h18"
                    })
                  ], -1),
                  _createTextVNode(" Tutup Preview ", -1)
                ]))])
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[9] || (_cache[9] = [
        _createElementVNode("div", { class: "text-center" }, [
          _createElementVNode("div", { class: "w-8 h-8 border-2 border-gray-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-3" }),
          _createElementVNode("p", { class: "text-sm text-gray-400" }, "Memuat preview...")
        ], -1)
      ]))]))
}
}

})